export class Settings {
  public MerchantId: number;
  public FirstName: string;
  public LastName: string;
  public Email: string;
  public ContactNumber: string;
  public Address: string;
  public BusinessName: string;
  public Industry: string;
  public LocationId: number;
  public Address1: string;
  public Phone: string;
  public CountryCode: string;
  public City: string;
  public PostalCode: string;
  public Province: string;
  public Logo: string;
  public StateId: string;
  public Package?: string;
  public MCCCode?: string;
  public HeartlandMerchantID?: string;
}

export class IntegrationModel {
  Id: number;
  ApplicationName: string;
  Account: string;
  IsActive: boolean;
  UpdatedDate: Date;
  CreatedDate: Date;
  SynchDate: Date;
  CreatedBy: number;
  UpdatedBy: number;
}
